import clsx from 'clsx'
import {useContext, useEffect, useState} from 'react'
import {FiMenu} from 'react-icons/fi'
import {Link} from 'react-router-dom'
import {useLayout} from '../../core'
// import {Header} from './Header'
import {DefaultTitle} from './page-title/DefaultTitle'
import {Topbar} from './Topbar'
import {ISettingTypeState} from 'src/app/modules/siteSettings/components/settings'
import {useSelector} from 'react-redux'
import {isEmpty} from 'lodash'
import {imageBaseUrl} from 'src/cms/helpers/constants'
import {Button} from 'antd'
import {FaBars} from 'react-icons/fa'
import {ActiveMenuContex} from '../../MasterLayout'
import {Header} from 'antd/es/layout/layout'

export function HeaderWrapper() {
  const {config, classes, attributes} = useLayout()
  const {header, aside} = config
  const [logo, setLogo] = useState('')
  const activeMenu: any = useContext(ActiveMenuContex)
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'mainLogo') {
            setLogo(item?.value)
          }
        })
    }
  }, [settingTypeData])
  const showDrawer = () => {
    activeMenu.setOpen(true)
  }
  return (
    <Header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1055,
        boxShadow: 'rgba(122, 122, 122, 0.12) 0px 0.4rem 0.7rem',
        background: '#043f86',
      }}
      className='d-flex align-items-center justify-content-between'
    >
      <div>
        <Button
          type='primary'
          color='default'
          size='large'
          icon={<FaBars />}
          style={{marginRight: '1rem'}}
          onClick={showDrawer}
        />
        <Link to='/dashboard'>
          <img
            alt='Logo'
            className=' logo'
            height={45}
            src='https://www.machbank.com/assets/backend/uploads/Logo/new%20logo.JPG'
            // src={`${imageBaseUrl}/${logo}`}
          />
        </Link>
      </div>

      <Topbar />
    </Header>
  )
}
